var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadcrumb-title-container",class:_vm.color},[_c('div',{staticClass:"vertical-line"}),_c('div',{staticClass:"flex-col"},[_c('breadcrumb'),_c('h1',[_vm._v(_vm._s(_vm.title))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }